import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import AppStyle from "./App.module.css";
import {
  getTextLiteral,
  getTopDisclaimer
  // getPageDisclaimer,
} from "./service/textRetrieval";

import VOCVOIProgressionChart from "components/VOCVOIProgressionChart/ProgressionChart";
import {getData} from "service/GenericData";
// import VOCVOIContinentsPieCharts from "components/VOCVOIContinentsPieCharts/PieCharts";

function App() {
  const [textLiterals, setTextLiterals] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);
  const [charts, setCharts] = React.useState(["Vp"]);
  const [topDisclaimer, setTopDisclaimer] = React.useState("");
  const [topDisclaimerTmp, setTopDisclaimerTmp] = React.useState("");
  const [utctime, setUtctime] = React.useState();
  // const [urlParams,setUrlParams] = React.useState([]);

  // method 2: test url: http://localhost:3000/?sessionid=1
  React.useEffect(() => {
    getTextLiteral().then((textLiterals) => {
      setTextLiterals(textLiterals);
      setTopDisclaimerTmp(getTopDisclaimer(textLiterals));
      setIsLoading(false);
    });
    getData("utctime").then((result)=>{
      setUtctime(result.utcTimestamp);
    });
  }, []);

  React.useEffect(() => {
    setTopDisclaimer(topDisclaimerTmp.replace("<utcTimestamp>", utctime));
    // setIsLoading(false);
  },[topDisclaimerTmp,utctime]);

  return isLoading ? null : (
    <Container className={AppStyle.container}>
      <Row className="mb-3 mt-2 justify-content-center">
        <div className={AppStyle.topDisclaimer}>
            {topDisclaimer}
        </div>
      </Row>
      <Row className="mb-3 mt-3" >
        {charts.includes('Vp') &&
          <Col xs={12} lg={12} className="mb-4">
            <VOCVOIProgressionChart textLiterals={textLiterals}  />
          </Col>
        }
      </Row>
    </Container>
  );
}

export default App;
